import { AidsCalculatorFunnel } from '../../../components/tools/AidsCalculatorFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('coproprietes', 'calculer-mes-aides')!;

export default function CoproprieteCalculerMesAidesPage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/coproprietes"
        backLabel="Espace copropriétés"
        duration="2 min"
      >
        <AidsCalculatorFunnel initialProfile="copropriete" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace copropriétés', url: 'https://solutionecofrance.fr/coproprietes' },
          { name: 'Calculer mes aides', url: 'https://solutionecofrance.fr/coproprietes/calculer-mes-aides' },
        ]}
      />
    </>
  );
}
